import React from 'react';
import './MenuButton.css';

const MenuButton = ({ 
  onClick,
  children,
  variant = 'default',
  size = 'medium',
  className = '',
  ...props 
}) => {
  const baseClasses = 'menu-btn';
  const variantClasses = `menu-btn-${variant}`;
  const sizeClasses = `menu-btn-${size}`;
  
  const classes = [baseClasses, variantClasses, sizeClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={classes}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default MenuButton;



